import React, { useState } from "react";
import { Heading5, Heading6 } from "components/text/heading/style";
import billing_theme from "style/theme_colors";
import BillingCheckbox from "components/input/checkbox";
import { NovoContratoConfiguracao } from "./style";
import BillingNumberInput from "components/input/number_input";
import { NovoContratoInputLabel } from "../contratos/style";
import BillingSelectInput from "components/input/select";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "store/store";
import {
  setIndiceState,
  setProRataDesinstacao,
  setProRataInstacao,
  setValorNaoReajustavel,
  setValorReajuste,
} from "store/contrato/view_contrato_slice";

const NovoContratoConfiguracaoComp: React.FC = () => {
  const enumList = useSelector((state: RootState) => state.list_enum);
  const view_contrato = useSelector((state: RootState) => state.view_contrato);
  const dispatch = useAppDispatch();

  const [naoReajustavel, setNaoReajustavel] = useState<number>(0);
  return (
    <NovoContratoConfiguracao>
      <Heading5 fontWeight={700} color={billing_theme.pallete.tertiary.A600}>
        Configurações
      </Heading5>

      <div className="configInput">
        <NovoContratoInputLabel>
          <Heading6 fontWeight={600} color={billing_theme.pallete.tertiary.A600}>
            Indice Reajuste
          </Heading6>
          <BillingSelectInput
            onChange={val => {
              val !== null
                ? dispatch(setIndiceState(Number(val.value!)))
                : dispatch(setIndiceState(undefined));
            }}
            options={enumList.IndiceReajusteOptions!}
            placeholder={"Indice de reajuste"}
          />
        </NovoContratoInputLabel>
        <NovoContratoInputLabel>
          <Heading6 fontWeight={600} color={billing_theme.pallete.tertiary.A600}>
            Valor reajustavel
          </Heading6>
          <BillingNumberInput
            format="currency"
            placeholder="Valor do reajsute"
            value={view_contrato.ValorReajustavel}
            onNumberFormat={value => {
              dispatch(setValorReajuste(value.number));
              setNaoReajustavel(view_contrato.Mensalidade! - value.number);
              dispatch(setValorNaoReajustavel(view_contrato.Mensalidade! - value.number));
            }}
            error={view_contrato.Mensalidade! < view_contrato.ValorReajustavel!}
            errorMesage="O valor não deve ser maior que a mensalidade!"
          />
        </NovoContratoInputLabel>
        <NovoContratoInputLabel>
          <Heading6 fontWeight={600} color={billing_theme.pallete.tertiary.A600}>
            Valor não reajustavel
          </Heading6>
          <BillingNumberInput
            format="currency"
            disabled={true}
            placeholder="Valor não reajustavel"
            value={naoReajustavel}
            alterValue={naoReajustavel}
            error={view_contrato.Mensalidade! < view_contrato.ValorReajustavel!}
            errorMesage="O valor não pode ser negativo"
          />
        </NovoContratoInputLabel>
      </div>

      <div className="prorata">
        <BillingCheckbox
          label="Aplicar pro rata da instalação."
          change={value => {
            dispatch(setProRataInstacao(value!));
          }}
        />
        <BillingCheckbox
          label="Aplicar pro rata na desinstalação."
          change={value => {
            dispatch(setProRataDesinstacao(value!));
          }}
        />
      </div>
    </NovoContratoConfiguracao>
  );
};
export default NovoContratoConfiguracaoComp;
